/**
 * Carrega JS do carrossel de vídeos só quando a seção entra no viewport.
 */
(function () {
  const sections = document.querySelectorAll('[data-andrade-lazy-carousel]');
  if (!sections.length) return;

  const loadScript = (url) =>
    new Promise((resolve, reject) => {
      if (!url) {
        resolve();
        return;
      }
      const existing = document.querySelector(`script[src="${url}"]`);
      if (existing) {
        if (existing.dataset.loaded === 'true' || existing.readyState === 'complete') {
          resolve();
          return;
        }
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', () => resolve(), { once: true });
        return;
      }
      const s = document.createElement('script');
      s.src = url;
      s.defer = true;
      s.onload = () => {
        s.dataset.loaded = 'true';
        resolve();
      };
      s.onerror = () => resolve();
      document.head.appendChild(s);
    });

  const boot = async (root) => {
    if (root.dataset.lazyLoaded === 'true') return;
    root.dataset.lazyLoaded = 'true';
    try {
      await loadScript(root.dataset.lazySwatches || '');
      await loadScript(root.dataset.lazyJs || '');
      root.querySelectorAll('video-testimonials-carousel').forEach((el) => {
        if (typeof customElements.upgrade === 'function') customElements.upgrade(el);
        if (typeof el.reloadSlides === 'function') el.reloadSlides();
      });
      window.AndradeVideoCarousel?.refresh(root);
    } catch (_) {
      /* ignore */
    }
  };

  if (document.documentElement.classList.contains('shopify-design-mode') || !('IntersectionObserver' in window)) {
    sections.forEach((s) => boot(s));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        io.unobserve(entry.target);
        boot(entry.target);
      }
    },
    { rootMargin: '400px 0px', threshold: 0.01 }
  );

  sections.forEach((s) => io.observe(s));
})();
